import { Building2, House } from "lucide-react";

/**
 * The price and the Service Location of a booking row, as two tinted chips:
 * the price on the accent, the location on a tint of the ink. Shared by the
 * consumer's and the clinic's bookings lists so the two rows read alike.
 */
export function BookingFacts({
  priceDisplay,
  locationLabel,
  atHome,
}: {
  priceDisplay: string;
  locationLabel: string;
  atHome: boolean;
}) {
  const Place = atHome ? House : Building2;
  return (
    <p className="mt-2.5 flex flex-wrap items-center gap-2 text-sm">
      <span className="rounded-md bg-accent/10 px-2 py-0.5 font-mono font-semibold text-accent">
        {priceDisplay}
      </span>
      <span className="inline-flex items-center gap-1 rounded-md bg-ink/6 px-2 py-0.5 font-medium text-ink">
        <Place className="size-3.5 text-accent" aria-hidden />
        {locationLabel}
      </span>
    </p>
  );
}
